module.exports = __webpack_public_path__ + "img/about.474027fc.svg";